import { useGlobalQuery } from '@/state/query-client/hooks';
import { useAuthStore } from '@/state/store/auth';
import {
  getPmReviewById,
  getPmReviewDetailsForReview,
  getPmReviews,
} from '../services/review-core.service';
import { QueryParams } from '../types/review-core.types';

export const REVIEW_QUERY_KEYS = {
  reviews: 'hr-pm-reviews',
  review: 'hr-pm-review',
  details: 'hr-pm-review-details',
  detail: 'hr-pm-review-detail',
  reviewDetails: 'hr-pm-review-details-for-review',
} as const;

export const useCurrentUserId = () => useAuthStore((state) => state.user?.itemId) ?? '';

export const useGetPmReviews = (params: QueryParams, enabled = true) =>
  useGlobalQuery({
    queryKey: [REVIEW_QUERY_KEYS.reviews, params],
    queryFn: () => getPmReviews(params),
    staleTime: 60 * 1000,
    enabled,
  });

export const useGetPmReviewById = (itemId?: string) =>
  useGlobalQuery({
    queryKey: [REVIEW_QUERY_KEYS.review, itemId],
    queryFn: () => getPmReviewById(itemId as string),
    enabled: Boolean(itemId),
  });

export const useGetPmReviewDetailsForReview = (pmReviewId?: string, reviewType?: string) =>
  useGlobalQuery({
    queryKey: [REVIEW_QUERY_KEYS.reviewDetails, pmReviewId, reviewType],
    queryFn: () => getPmReviewDetailsForReview(pmReviewId as string, reviewType),
    enabled: Boolean(pmReviewId),
  });
